export default {"src":"/_next/static/media/signup_icon_3.81dd2b87.svg","height":32,"width":32};